import { EventEmitter } from "events";

export type events = "play";
export const eventBus = new EventEmitter();
